import { modifications as actionTypes } from "store/constants";
import {
	reduceIsFetching,
	reduceSetError,
	fetchableInitialState,
} from "store/factories/fetchable";
import {
	reduceSetItems,
	reduceSetSort,
	reduceSetPaging,
	addItems,
	reduceSetSearch,
} from "store/factories/feed";
import { baseInitialState } from "store/factories/initialState";


const initialState = {
	content: {
		...fetchableInitialState,
		...baseInitialState.content,
	},
};

export function modificationList (state = initialState, action) {
	switch (action.type) {
	case actionTypes.MODIFICATIONS_IS_FETCHING:
		return reduceIsFetching(state, action);
	case actionTypes.MODIFICATIONS_SET_ERROR:
		return reduceSetError(state, action);
	case actionTypes.MODIFICATIONS_SET_DATA:
		return {
			...state,
			content: {
				...state.content,
        ...action.payload,
			},
		};
	case actionTypes.SET_ITEMS:
		return reduceSetItems(state, action);
	case actionTypes.SET_SORT:
		return reduceSetSort(state, action);
	case actionTypes.SET_PAGING:
		return reduceSetPaging(state, action);
	case actionTypes.ADD_ITEMS:
		return addItems(state, action);
	case actionTypes.RESET:
		return initialState;
	case actionTypes.SET_SEARCH:
		return reduceSetSearch(state, action);
	default:
		return state;
	}
}


